import { Link } from 'react-router-dom';
import styles from './SearchMenu.module.css';

interface SearchMenuProps {
  rendered: boolean;
}

const SearchMenu = (props: SearchMenuProps) => {
  if (!props.rendered) {
    return null;
  }

  return (
    <div className={styles.searchMenu}>
      <Link to={'/fsok/SokPaOrganisationsnummer.seam'}>Företag</Link>
      <Link to={'/fsok/SokFastighet.seam'}>Fastighet</Link>
      <Link to={'/fsok/SokPaAkt.seam'}>Akt</Link>
      <Link to={'/fsok/Forteckningar.seam'}>Förteckningar</Link>
      <Link to={'/fsok/Bostadsvardering.seam'}>Bostadsvärdering</Link>
    </div>
  );
};

export default SearchMenu;
